"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGetPageData = void 0;
var interfaces_1 = require("@hudled/interfaces");
var groupBy_1 = __importDefault(require("lodash/groupBy"));
var sortBy_1 = __importDefault(require("lodash/sortBy"));
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var react_redux_firebase_1 = require("react-redux-firebase");
var react_router_dom_1 = require("react-router-dom");
var backend_1 = require("utils/backend");
var recommendationsFilterHooks_1 = require("utils/hooks/recommendationsFilterHooks");
var populated_1 = require("utils/selectors/populated");
var single_1 = require("utils/selectors/single");
var utils_1 = require("utils/selectors/utils");
var utils_2 = require("./utils");
// const RECOMMENDATIONS_TYPE_ORDER = [RECOMMENDATIONS_TYPE.FX, RECOMMENDATIONS_TYPE.PAPR, RECOMMENDATIONS_TYPE.M2Y,
//   RECOMMENDATIONS_TYPE.DORM, RECOMMENDATIONS_TYPE.USUB, RECOMMENDATIONS_TYPE.ALT, RECOMMENDATIONS_TYPE.NEGOT];
var RECOMMENDATIONS_TYPE_ORDER = [interfaces_1.RECOMMENDATIONS_TYPE.FX, interfaces_1.RECOMMENDATIONS_TYPE.NEGOT];
var useGetPageData = function () {
    var profile = (0, react_redux_1.useSelector)(single_1.selectProfile);
    // const auth = useSelector(selectAuth);
    var where = ['companyId', '==', profile.companyId];
    // const whereRecommendations = profile.accessLevel !== ACCESS_LEVEL.Owner
    //   ? [where, ['assigneeId', '==', auth.uid] as WhereOptions]
    //   : where;
    var _a = __read((0, backend_1.useCall)('recommendations-callCalculateForCompany'), 2), calculateRecommendationsForCompany = _a[0], isCalculating = _a[1];
    react_1.default.useEffect(function () {
        calculateRecommendationsForCompany(profile.companyId)();
    }, []);
    (0, react_redux_firebase_1.useFirestoreConnect)(function () { return [{ collection: 'recommendations', where: where }]; });
    var location = (0, react_router_dom_1.useLocation)();
    var recommendations1 = (0, utils_1.useDebouncedSelector)(populated_1.selectPopulatedRecommendationsArray) || [];
    // to update??
    var _b = __read((0, recommendationsFilterHooks_1.useAssigneesFilter)(recommendations1), 3), recommendations = _b[0], setOwnersToFilterBy = _b[1], ownersToFilterBy = _b[2];
    var _c = __read((0, recommendationsFilterHooks_1.useStatusFilter)(recommendations), 3), recommendationsFilteredByStatus = _c[0], setStatusToFilterBy = _c[1], statusToFilterBy = _c[2];
    var _d = (0, react_1.useMemo)(function () {
        var _a;
        if (!recommendations) {
            return ({
                recommendationsToDisplay: recommendations,
                recommendationsGroups: {},
            });
        }
        var selectedRecTypes = (_a = (0, utils_2.getSelectedRecommendationTypes)(location)) === null || _a === void 0 ? void 0 : _a.map(function (rt) { return interfaces_1.RECOMMENDATIONS_TYPE[rt]; });
        var ordered = (0, sortBy_1.default)(recommendationsFilteredByStatus, function (r) { return RECOMMENDATIONS_TYPE_ORDER.indexOf(r.type); });
        var recommendationsFiltered = ordered
            .filter(function (r) { return !r.isSoftDelete; }) // ToDo: move to selector
            .filter(function (r) { var _a; return (_a = selectedRecTypes === null || selectedRecTypes === void 0 ? void 0 : selectedRecTypes.includes(r.type)) !== null && _a !== void 0 ? _a : true; });
        return ({
            recommendationsToDisplay: recommendationsFiltered,
            recommendationsGroups: (0, groupBy_1.default)(recommendationsFiltered, function (r) { return r.type; }),
        });
    }, [recommendationsFilteredByStatus]), recommendationsToDisplay = _d.recommendationsToDisplay, recommendationsGroups = _d.recommendationsGroups;
    return [
        recommendationsToDisplay,
        setOwnersToFilterBy,
        ownersToFilterBy,
        setStatusToFilterBy,
        statusToFilterBy,
        recommendationsGroups,
        isCalculating,
    ];
};
exports.useGetPageData = useGetPageData;
